import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 0h32v36H0z" />
    <path
      stroke="#04260E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 31.06c8.301 0 15.03-6.729 15.03-15.03C31.03 7.73 24.301 1 16 1 7.699 1 .97 7.73.97 16.03c0 8.301 6.729 15.03 15.03 15.03Z"
    />
    <path
      stroke="#04260E"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.33 9.35v8.35h8.35"
    />
  </svg>
);
export default SvgComponent;
